import { NgModule } from '@angular/core';
import { AppSharedModule } from '@gestor-web/app/shared/modules';
import { PesquisarInputComponent } from './pesquisar-input.component';

@NgModule({
  declarations: [PesquisarInputComponent],
  exports: [PesquisarInputComponent],
  imports: [AppSharedModule],
})
export class PesquisarInputModule {}
